import { render, staticRenderFns } from "./PrivacyAuditMainTab.vue?vue&type=template&id=547fc562&"
import script from "./PrivacyAuditMainTab.vue?vue&type=script&lang=js&"
export * from "./PrivacyAuditMainTab.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyAuditMainTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PrivacyAuditMainTab.vue"
export default component.exports